import chargeRequest from '../utils/chargeRequest'

// 获取基本发票基本信息
export function getInvoiceBaseInfo() {
  return chargeRequest({
    url: '/app/invoice/user/ticket/default',
    method: 'post'
  })
}

// 获取用户抬头信息表分页列表
export function getInvoiceTitleList(type: any) {
  return chargeRequest({
    url: '/app/invoice/user/title/pageList',
    method: 'post',
    data: { type }
  })
}

// 获取用户抬头信息表详情
export function getInvoiceTitleDetail(id: any) {
  return chargeRequest({
    url: '/app/invoice/user/title/detail?id=' + id,
    method: 'get'
  })
}

// 新增用户抬头信息表信息
export function addInvoiceTitle(data: any) {
  return chargeRequest({
    url: '/app/invoice/user/title/add',
    method: 'post',
    data
  })
}

// 编辑用户抬头信息表信息
export function editInvoiceTitle(data: any) {
  return chargeRequest({
    url: '/app/invoice/user/title/edit',
    method: 'post',
    data
  })
}

// app开票
export function createInvoice(data: any) {
  return chargeRequest({
    url: '/app/invoice/user/ticket/create',
    method: 'post',
    data
  })
}

// 获取app票据单记录列表记录
export function getInvoiceRecord(data: any) {
  return chargeRequest({
    url: '/app/invoice/user/ticket/pageList',
    method: 'post',
    data
  })
}

// 重新发送发票
export function resendInvoice(data: any) {
  return chargeRequest({
    url: '/app/invoice/user/ticket/sendEmail',
    method: 'post',
    data
  })
}

// 删除发票抬头
export function deleteInvoiceTitle(id: any) {
  return chargeRequest({
    url: '/app/invoice/user/title/delete',
    method: 'post',
    data: {id}
  })
}
